export function cityStringIncludeParentheses(city: string) {
    if (city) {
        const cityString = city.split(" ");
        if (cityString.length > 1 || city.indexOf("(") != -1) {
            return city.slice(0, -4);
        } else {
            return city;
        }
    } else {
        return "";
    }
}
